import * as React from 'react';
import './index.scss';
import { StageDefault } from '@/context.ts';
import { RankItem, GetRichRankRsp } from '@/fetch.ts';
import RankHeader from '@hooks/web/public/rankHeader.tsx';
import AnchorItem from '@hooks/web/public/anchorItem.tsx';
import Page from '@hooks/web/public/page.tsx';
import None from '@hooks/web/public/none.tsx';
const { useEffect, useState, useContext } = React;
interface Props {
  list: RankItem[],
  title: string,
  index: number,
}
const DetailList: React.FC<Props> = props => {
  const [showList, ShowList] = useState<RankItem[]>([]);
  const pageChange = (index: number): void => {
    ShowList(props.list.slice((index) * 5, (index + 1) * 5 >= props.list.length ? props.list.length : (index + 1) * 5));
  }
  useEffect(() => {
    ShowList(props.list.slice(0, 5));
  }, [props.list])
  return (
    <li
      className='web-detailList'
    >
      <div className='label'>
        <i className='icon'></i>
        <p>{props.title}</p>
      </div>
      <RankHeader
        width={360}
        color='#ffefbf'
        prev='排名'
        mid={['神豪', '主播', '主播'][props.index] + '昵称'}
        next={['贡献值', '贡献星光', '贡献星光'][props.index]}
      />
      <div className='listCover'>
        {
          showList.length === 0 ?
            <None text={`暂无${props.title}数据`} />
            :
            showList.map((item: RankItem) => (
              <AnchorItem
                key={item.tJump.lPid}
                width={360}
                {...item}
                small={true}
                jump={[false, true, true][props.index]}
              />
            ))
        }
      </div>
      <Page
        pageLen={props.list.length % 5 === 0 ? props.list.length / 5 : Math.floor(props.list.length / 5) + 1}
        setPageIndex={pageChange}
      />
    </li>
  )
}

export default DetailList;